import * as types from '../actions/types';

const initialState = {
  modalType: null,
  props: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW_CONFIRM_MODAL:
      return {
        ...state,
        modalType: action.payload.modalType,
        props: action.payload.props,
      };
    case types.HIDE_CONFIRM_MODAL:
      return initialState;
    default:
      return state;
  }
};
